export default "__VITE_ASSET__CddF8T95__"